import styled from 'styled-components'

const WrapHome = styled.div`
    
`;

export {
    WrapHome
}